"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _developerExperienceService = require("@insided/shared/services/developerExperienceService");

var _preactPortal = _interopRequireDefault(require("preact-portal"));

/**
 * Parse debug data from element's data-debug attribute (server-provided only)
 *
 * Hydration Mismatch Detection:
 * - Automatically compares SSR and CSR HTML to detect mismatches
 * - Respects `suppressHydrationWarning` attribute to skip intentional differences
 *
 * Usage in components with intentional SSR/CSR differences:
 * ```tsx
 * <div suppressHydrationWarning>
 *   {clientOnlyContent}
 * </div>
 * ```
 *
 * Common use cases:
 * - Downshift/autocomplete components (client-side only IDs)
 * - Client-side feature detection (browser APIs)
 * - Progressive enhancement (JS-dependent features)
 * - Third-party widgets (analytics, chat, etc.)
 */
function parseDebugData(el) {
  if (!_developerExperienceService.developerExperienceService.isDebugModeClient()) return null;
  if (!el.dataset.debug) return null;

  try {
    return JSON.parse(el.dataset.debug);
  } catch (_unused) {
    return null;
  }
}
/** Handles debug data lifecycle and UI rendering for SSR components */


var ComponentDebugger = /*#__PURE__*/function () {
  function ComponentDebugger(el) {
    (0, _classCallCheck2.default)(this, ComponentDebugger);
    (0, _defineProperty2.default)(this, "el", void 0);
    (0, _defineProperty2.default)(this, "debugData", null);
    (0, _defineProperty2.default)(this, "hydrationStartTime", undefined);
    (0, _defineProperty2.default)(this, "hydrationEndTime", undefined);
    (0, _defineProperty2.default)(this, "hydrationError", undefined);
    this.el = el;
    this.debugData = parseDebugData(el);
  }
  /** Mark hydration start time */


  (0, _createClass2.default)(ComponentDebugger, [{
    key: "markHydrationStart",
    value: function markHydrationStart() {
      if (!_developerExperienceService.developerExperienceService.isDebugModeClient()) return;
      if (!this.debugData) return;
      this.hydrationStartTime = Date.now();
    }
    /** Mark hydration end time */

  }, {
    key: "completeHydration",
    value: function completeHydration() {
      if (!_developerExperienceService.developerExperienceService.isDebugModeClient()) return;
      if (!this.debugData) return;
      this.hydrationEndTime = Date.now();
    }
    /** Render debug panel with Preact Portal (call after completeHydration) */

  }, {
    key: "render",
    value: function () {
      var _render = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        var container;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_developerExperienceService.developerExperienceService.isDebugModeClient()) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                if (this.debugData) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt("return");

              case 4:
                if (!this.el.dataset.debugPanelId) {
                  _context.next = 6;
                  break;
                }

                return _context.abrupt("return");

              case 6:
                container = this.createPortalContainer();
                _context.next = 9;
                return this.renderDebugComponent(container);

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function render() {
        return _render.apply(this, arguments);
      }

      return render;
    }()
    /**
     * Create and insert portal container for debug panel
     *
     * Inserts the debug portal as a sibling BEFORE the component element.
     * This keeps the component's innerHTML clean for hydration mismatch analysis.
     *
     * @example
     * Resulting DOM structure:
     * ```html
     * <parent>
     *   <div class="debug-details-portal" id="debug-component-123-abc">
     *     <!-- Portal renders DebugMode here -->
     *   </div>
     *   <div data-preact="component-name" data-props="{...}" data-debug-panel-id="debug-component-123-abc">
     *     [SSR HTML CONTENT]
     *   </div>
     * </parent>
     * ```
     */

  }, {
    key: "createPortalContainer",
    value: function createPortalContainer() {
      var _this$el$parentNode;

      var panelId = this.generatePanelId();
      this.el.dataset.debugPanelId = panelId;
      var container = document.createElement('div');
      container.id = panelId;
      container.className = 'debug-details-portal';
      (_this$el$parentNode = this.el.parentNode) === null || _this$el$parentNode === void 0 ? void 0 : _this$el$parentNode.insertBefore(container, this.el);
      return container;
    }
    /** Lazy-load and render the DebugMode component */

  }, {
    key: "renderDebugComponent",
    value: function () {
      var _renderDebugComponent = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(container) {
        var _yield$import, DebugMode, csrDebugData;

        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (this.debugData) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return");

              case 2:
                _context2.next = 4;
                return import('@insided/destination/modules/DebugMode');

              case 4:
                _yield$import = _context2.sent;
                DebugMode = _yield$import.DebugMode;
                csrDebugData = {
                  hydration: {
                    start: this.hydrationStartTime,
                    end: this.hydrationEndTime,
                    error: this.hydrationError
                  },
                  analysis: this.analyzeHydrationMismatch()
                };
                (0, _preact.render)((0, _preact.h)(_preactPortal.default, {
                  into: container
                }, (0, _preact.h)(DebugMode, {
                  debugData: this.debugData,
                  csrDebugData: csrDebugData,
                  targetElement: this.el
                })), container);

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function renderDebugComponent(_x) {
        return _renderDebugComponent.apply(this, arguments);
      }

      return renderDebugComponent;
    }()
    /** Get current client HTML for hydration analysis */

  }, {
    key: "clientHtml",
    get: function get() {
      return this.el.innerHTML;
    }
    /** Get SSR HTML from data attribute */

  }, {
    key: "ssrHtml",
    get: function get() {
      var _this$el$dataset$ssrH;

      return (_this$el$dataset$ssrH = this.el.dataset.ssrHtml) !== null && _this$el$dataset$ssrH !== void 0 ? _this$el$dataset$ssrH : null;
    }
    /** Analyze hydration mismatch by comparing SSR and client HTML */

  }, {
    key: "analyzeHydrationMismatch",
    value: function analyzeHydrationMismatch() {
      if (!this.ssrHtml) {
        return null;
      }

      var parser = new DOMParser();
      var ssrDoc = parser.parseFromString(this.ssrHtml, 'text/html');
      var clientDoc = parser.parseFromString(this.clientHtml, 'text/html');
      var ssrRoot = ssrDoc.body.firstElementChild;
      var clientRoot = clientDoc.body.firstElementChild;

      if (!ssrRoot || !clientRoot) {
        return {
          hydrationMismatch: true
        };
      } // Check if there's a suppressHydrationWarning anywhere in the tree


      if (this.hasSupressHydrationWarningInTree(ssrRoot) || this.hasSupressHydrationWarningInTree(clientRoot)) {
        return {
          hydrationMismatch: false
        };
      } // Use native isEqualNode() for deep comparison


      var isEqual = ssrRoot.isEqualNode(clientRoot);
      return {
        hydrationMismatch: !isEqual
      };
    }
    /**
     * Walk the DOM tree to check if any element has suppressHydrationWarning
     * Uses TreeWalker for efficient traversal
     */

  }, {
    key: "hasSupressHydrationWarningInTree",
    value: function hasSupressHydrationWarningInTree(root) {
      var walker = document.createTreeWalker(root, NodeFilter.SHOW_ELEMENT, null);
      var node = walker.currentNode;

      while (node) {
        if (node.nodeType === Node.ELEMENT_NODE) {
          var elem = node;

          if (elem.hasAttribute('suppresshydrationwarning')) {
            return true;
          }
        }

        node = walker.nextNode();
      }

      return false;
    }
    /** Generate a unique ID for debug panel */

  }, {
    key: "generatePanelId",
    value: function generatePanelId() {
      var componentName = this.el.dataset.preact || 'component';
      var timestamp = Date.now();
      var random = Math.random().toString(36).slice(2, 9);
      return "debug-".concat(componentName, "-").concat(timestamp, "-").concat(random);
    }
  }]);
  return ComponentDebugger;
}();

exports.default = ComponentDebugger;